export default __webpack_public_path__ + "static/media/3.c095b24c.jpg";